import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";
import { getSuppliersDetail } from "../../connections/getSuppliersDetail";
import { deleteSuppliers } from "../../connections/deleteSuppliers";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";
// import { Table } from "antd";
// const columns = [
//   {
//     title: "Id",
//     dataIndex: "id",
//     // sorter: (a, b) => a.ConsultingDoctor.length - b.ConsultingDoctor.length,/
//   },
//   {
//     title: "Name",
//     dataIndex: "name",
//     // sorter: (a, b) => a.name - b.name,
//   },
//   {
//     title: "Phone",
//     dataIndex: "phone",
//     //   sorter: (a, b) => a.ConsultingDoctor.length - b.ConsultingDoctor.length,
//     // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY HH:mm")}</>,
//   },
//   {
//     title: "Gst No",
//     dataIndex: "gst_no",
//     //   sorter: (a, b) => a.Treatment.length - b.Treatment.length,
//     // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY HH:mm")}</>,
//   },
//   {
//     title: "Address",
//     dataIndex: "address",
//     //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
//     // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY")}</>,
//   },
//   {
//     title: "Email",
//     dataIndex: "email",
//     //   sorter: (a, b) => a.Email.length - b.Email.length,
//     //   render: (text, record) => (
//     //     <>
//     //       <Link to="#">{record.Mobile}</Link>
//     //     </>
//     //   ),
//   },
//   {
//     title: "Created At",
//     dataIndex: "created_at",
//     render: (date) => (
//       <>
//         {date}
//       </>
//     ),
//   },
//   {
//     title: "Updated At",
//     dataIndex: "updated_at",
//     render: (date) => (
//       <>
//         {date}
//       </>
//     ),
//   },

// ];
const SuppliersDetail = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [supplierId, setSupplierId] = useState("");
  const navigate = useNavigate();
  const { data: getSuppliersDetails, isLoading } = useQuery({
    queryKey: ["getSuppliersDetail", id],
    queryFn: () => getSuppliersDetail(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const suppliersListData = getSuppliersDetails ? [getSuppliersDetails] : [];
  const deleteSupplier = async () => {
    try {
      await deleteSuppliers(user?.token, supplierId);
      toast.success("Supplier Deleted Successfully", supplierId);
      navigate("/admin/suppliers");
      setSupplierId(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar
        id="menu-item4"
        id1="menu-items4"
        activeClassName="suppliers-list"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Supplier Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Supplier Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/update-suppliers", {
                                    state: getSuppliersDetails,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setSupplierId(getSuppliersDetails?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Id:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.id || "N/A"}
                                  </span>
                                </li>
                                {/* <li className="pb-1">
                                  <span className="title">UID:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.uid || "N/A"}
                                  </span>
                                </li> */}
                                <li className="pb-1">
                                  <span className="title"> Name:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.name || "N/A"}
                                  </span>
                                </li>
                                {/* <li className="pb-1">
                                  <span className="title">Last Name:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.last_name || "N/A"}
                                  </span>
                                </li> */}
                                <li className="pb-1">
                                  <span className="title">Mobile:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.phone || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Email:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.email || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Gst No:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.gst_no || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Address:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.address || "N/A"}
                                  </span>
                                </li>
                                {/* <li className="pb-1">
                                  <span className="title">Marital Status:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.marital_status ||
                                      "N/A"}
                                  </span>
                                </li> */}
                                {/* <li className="pb-1">
                                  <span className="title">Active:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.active ? (
                                      <span className="custom-badge status-green">
                                        True
                                      </span>
                                    ) : (
                                      <span className="custom-badge status-pink">
                                        False
                                      </span>
                                    )}
                                  </span>
                                </li> */}
                                {/* <li className="pb-1">
                                  <span className="title">SP Type:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.sp_type || "N/A"}
                                  </span>
                                </li> */}
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.created_at
                                      ? formatDateTime(
                                          getSuppliersDetails?.created_at
                                         
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {getSuppliersDetails?.updated_at
                                      ? formatDateTime(
                                          getSuppliersDetails?.updated_at
                                         
                                        )
                                      : "N/A"}
                                  </span>
                                </li>
                                {/* <li className="pb-1">
                                  <span className="title">Details:</span>
                                  <span
                                    className="text"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        getSuppliersDetails?.details || "N/A",
                                    }}
                                  />
                                </li> */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      //   <div className="table-responsive doctor-list">
                      //   <Table
                      //     pagination={false}
                      //     columns={columns}
                      //     dataSource={suppliersListData}
                      //     rowKey={(record) => record.id}
                      //     scroll={{ x: "max-content" }}

                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={deleteSupplier}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default SuppliersDetail;
